import axios from 'axios';

const getMatrices = (companyId, args) => axios.get(`/company/${companyId}/ninebox`, {params: args});

const getMatrixDetails = (matrixId) => axios.get(`/ninebox/${matrixId}`);

const getCalibrationHistory = (matrixId, dataId) =>
  axios.get(`/ninebox/${matrixId}/data/${dataId}/history`);

const checkCreationMatrix = (data) => axios.post('/ninebox/getcount', data);

const createMatrix = (data) => axios.post('/ninebox', data);

const calibrateMatrix = (matrixId, data) => axios.post(`/ninebox/${matrixId}/calibrate`, data);

const deleteMatrix = (matrixId) => axios.delete(`/ninebox/${matrixId}`);

const changeStateMatrix = (matrixId, state) => axios.post(`/ninebox/${matrixId}/state/${state}`);

const exportMatrix = (matrixId, args) =>
  axios.get(`/ninebox/${matrixId}/export`, {
    responseType: 'blob',
    params: args,
  });

const exportMatrixDetails = (matrixId, args) =>
  axios.get(`/ninebox/${matrixId}/detail_export`, {
    responseType: 'blob',
    params: args,
  });

const importMatrix = (matrixId, data) =>
  axios.post(`/ninebox/${matrixId}/export`, data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

const setDeletedEmployees = (matrixId, data) =>
  axios.post(`/ninebox/${matrixId}/set_deleted`, data);

const addCalibrationEmployees = (matrixId, data) =>
  axios.post(`/ninebox/${matrixId}/calibration_list/add`, data);

const deleteCalibrationEmployees = (matrixId, data) =>
  axios.post(`/ninebox/${matrixId}/calibration_list/remove`, data);

export default {
  getMatrices,
  getMatrixDetails,
  getCalibrationHistory,

  checkCreationMatrix,
  createMatrix,
  calibrateMatrix,

  deleteMatrix,
  changeStateMatrix,

  exportMatrix,
  exportMatrixDetails,
  importMatrix,

  setDeletedEmployees,
  addCalibrationEmployees,
  deleteCalibrationEmployees,
};
